
import Vue from "vue";
import LargeCard from "../components/LargeCard.vue";
import CardData from "../models/CardData";
import { ICardData } from "../@types/interface.d";

interface IData {
  card?: CardData;
  notFound: boolean;
}

export default Vue.extend({
  name: "single-card",
  components: {
    LargeCard,
  },
  data(): IData {
    return {
      card: undefined,
      notFound: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { imageId } = this.$route.params;
      fetch(`/api/single_card/${imageId}`).then(res => res.json()).then((data: ICardData) => {
        this.card = new CardData(data);
      }).catch(() => {
        this.notFound = true;
      });
    },
  },
});
